import styled from 'styled-components/macro';

export const IconContainer = styled.div`
  width: 20px;
  height: 20px;
`;
